export default "__VITE_ASSET__CIrfUVLh__"